import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_5 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_6 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_7 = { class: "text-sm text-gray-900 truncate" }

import { computed, onMounted, ref } from 'vue'

import { onOffBadge, scheduledMessageTime } from '@/helpers/automationLists'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'
import NewAutomationButton from '@/view/automations/NewAutomationButton.vue'

const pageSize = 10

export default {
  __name: 'ScheduledMessageList',
  setup(__props) {

const loading = ref(true)
const page = ref(0)

const columns = [
  { width: 'minmax(160px, 1fr)' },
  { width: 'minmax(240px, 3fr)' },
  { width: 'minmax(160px, 1fr)' },
  { width: 'minmax(200px, 1fr)' },
  { width: '90px' }
]

const schedulerFor = automation =>
  automation.relationships?.automation_scheduler?.data &&
  mapRelationship(automation.relationships.automation_scheduler.data)

const automations = computed(() =>
  mapType('message_automation').sort((a, b) => {
    const aTime = new Date(schedulerFor(a)?.attributes?.datetime || 0)
    const bTime = new Date(schedulerFor(b)?.attributes?.datetime || 0)
    return bTime - aTime
  })
)
const pageRows = computed(() => automations.value.slice(page.value * pageSize, (page.value + 1) * pageSize))

const messageBody = automation => {
  const template =
    automation.relationships?.message_template?.data && mapRelationship(automation.relationships.message_template.data)
  return template?.attributes?.body || ''
}

const audienceNames = automation =>
  mapRelationships(automation.relationships?.audiences?.data || [])
    .map(audience => audience?.attributes?.audience_name)
    .filter(Boolean)
    .join(', ')

const scheduledTime = automation => scheduledMessageTime(schedulerFor(automation))

const statusBadge = automation => onOffBadge(automation.attributes.turned_on !== false, 'On', 'Off')

onMounted(() => {
  api.call('GET', 'message_automations?included=automation_scheduler,audiences,message_template').finally(() => {
    loading.value = false
  })
})

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Scheduled messages" }, {
        right: _withCtx(() => [
          _createVNode(NewAutomationButton, { type: "message" })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueWell, { class: "mb-8" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Scheduled messages go out to the customers on your chosen Smart Lists at a set time, once or on a repeating schedule. ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (automations.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: columns,
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("div", null, "Name", -1),
                                _createElementVNode("div", null, "Message", -1),
                                _createElementVNode("div", null, "Customer Smart Lists", -1),
                                _createElementVNode("div", null, "Scheduled", -1),
                                _createElementVNode("div", null, "Status", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRows.value, (automation) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: automation.id,
                            class: "cursor-pointer",
                            onClick: $event => (_ctx.$router.push('/automation/message/' + automation.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, { columns: columns }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(automation.attributes.name), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(messageBody(automation)), 1),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(audienceNames(automation)), 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(scheduledTime(automation)), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                          statusBadge(automation).classes,
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full'
                        ])
                                    }, _toDisplayString(statusBadge(automation).label), 3)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_NeuePagination, {
                    size: automations.value.length,
                    from: page.value * pageSize + 1,
                    to: Math.min((page.value + 1) * pageSize, automations.value.length),
                    onPrev: _cache[0] || (_cache[0] = 
                ret => {
                  page.value--
                  ret()
                }
              ),
                    onNext: _cache[1] || (_cache[1] = 
                ret => {
                  page.value++
                  ret()
                }
              )
                  }, null, 8, ["size", "from", "to"])
                ]))
              : (_openBlock(), _createBlock(_component_NeueWell, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EmptyState, { plural: "scheduled messages" })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}